import React from "react";
import { FiArrowRight, FiHome } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import LangLink from "../../components/shared/LangLink";
import fullLogo from "../../assets/images/darkthemelogo.svg";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <section className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-3xl rounded-3xl border border-white/15 bg-white/5 backdrop-blur-xl p-8 md:p-12 shadow-2xl">
      

        <p className="inline-flex px-3 py-1 rounded-full text-xs font-semibold tracking-widest bg-white/10 text-slate-200 mb-5">
          ERROR 404
        </p>
        <h1 className="text-4xl md:text-5xl font-bold leading-tight">{t("notFound.title")}</h1>
        <p className="text-slate-300 mt-4 max-w-xl">
          The page you are trying to access does not exist or you do not have permission to view it.
        </p>

        <div className="mt-8 flex flex-wrap gap-3">
          <LangLink
            to="/"
            className="inline-flex items-center gap-2 rounded-xl bg-white text-slate-900 px-5 py-3 font-semibold hover:bg-slate-200 transition"
          >
            <FiHome />
            Go Home
          </LangLink>
  
        </div>
      </div>
    </section>
  );
};

export default NotFound;
